import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateHelper } from './custom-date-helper';
import { formatISO } from 'date-fns';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  constructor(private helper: CustomDateHelper) {
    super();
  }

  fromModel(value: string | null): NgbDateStruct | null {
    return value ? this.helper.getNgbDate(value) : null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? formatISO(new Date(date.year, date.month - 1, date.day), { representation: 'date' }) : null;
  }
}
